import { render, staticRenderFns } from "./standardAttributes.vue?vue&type=template&id=a3c3db1e&scoped=true"
import script from "./standardAttributes.vue?vue&type=script&lang=js"
export * from "./standardAttributes.vue?vue&type=script&lang=js"
import style0 from "./standardAttributes.vue?vue&type=style&index=0&id=a3c3db1e&prod&lang=scss&scoped=true"
import style1 from "./standardAttributes.vue?vue&type=style&index=1&id=a3c3db1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c3db1e",
  null
  
)

export default component.exports